import {
  Box,
  Typography,
  Link,
  Divider,
  Stack,
  Grid,
  IconButton,
} from '@mui/material';

import { Link as RouterLink } from 'react-router-dom';

import PhoneIcon from '@mui/icons-material/Phone';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import { CONTACT, createWhatsAppUrl } from './siteConfig';
import VisitorStats from './VisitorStats';

function Footer() {
  const igIcon = {
    backgroundColor: '#E4405F',

    color: '#fff',

    '&:hover': { backgroundColor: '#c13584' },
  };

  return (
    <Box
      component='footer'
      sx={{
        backgroundColor: '#252728',

        color: '#cccccc',

        padding: '50px 30px',

        boxSizing: 'border-box',
      }}
    >
      <Divider sx={{ backgroundColor: '#4c4c4c', marginBottom: '30px' }} />

      <Grid container spacing={4} justifyContent='center'>
        {/* LINKS */}

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='subtitle1' fontWeight='bold' sx={{ mb: 2 }}>
            LINKS
          </Typography>

          <Stack spacing={1}>
            <Link component={RouterLink} to='/' sx={linkStyle}>
              Home
            </Link>

            <Link component={RouterLink} to='/pricing' sx={linkStyle}>
              Harga
            </Link>
            <Link component={RouterLink} to='/fleet' sx={linkStyle}>
              Corporate Fleet
            </Link>
            <Link component={RouterLink} to='/about-byd' sx={linkStyle}>
              Tentang Kami
            </Link>

            <Link component={RouterLink} to='/gallery' sx={linkStyle}>
              Galery
            </Link>

            <Link component={RouterLink} to='/test-drive' sx={linkStyle}>
              Test Drive
            </Link>

            <Link component={RouterLink} to='/contact' sx={linkStyle}>
              Kontak
            </Link>

            <Link
              href='https://instagram.com/bydbsdserpong'
              target='_blank'
              rel='noopener'
              sx={linkStyle}
            >
              Instagram
            </Link>

            <Link component={RouterLink} to='/privacy' sx={linkStyle}>
              Kebijakan Privasi
            </Link>
          </Stack>
        </Grid>

        {/* PILIHAN MOBIL */}

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='subtitle1' fontWeight='bold' sx={{ mb: 2 }}>
            PILIHAN MOBIL
          </Typography>

          <Stack spacing={1}>
            <Link component={RouterLink} to='/jelajahi-z9gt' sx={linkStyle}>
              Danza Z9 GT
            </Link>

            <Link component={RouterLink} to='/jelajahi-dolphin' sx={linkStyle}>
              Dolphin
            </Link>

            <Link component={RouterLink} to='/jelajahi-atto' sx={linkStyle}>
              ATTO 3 2024
            </Link>

            <Link component={RouterLink} to='/jelajahi-seal' sx={linkStyle}>
              Seal
            </Link>

            <Link component={RouterLink} to='/jelajahi-m6' sx={linkStyle}>
              M6
            </Link>
            <Link component={RouterLink} to='/jelajahi-m6-dm' sx={linkStyle}>
              M6 DM
            </Link>
            <Link component={RouterLink} to='/jelajahi-denzad9' sx={linkStyle}>
              Danza D9
            </Link>

            <Link
              component={RouterLink}
              to='/jelajahi-sealion-7'
              sx={linkStyle}
            >
              Sealion 7
            </Link>
            <Link component={RouterLink} to='/jelajahi-atto1' sx={linkStyle}>
              BYD Atto 1
            </Link>
          </Stack>
        </Grid>

        {/* KONTAK */}

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='subtitle1' fontWeight='bold' sx={{ mb: 2 }}>
            KONTAK KAMI
          </Typography>

          <Typography variant='body2'>
            <strong>BYD BSD CITY TANGERANG</strong>
            <br /> BSD City Serpong Kavling De Park
            <br /> Jl. BSD Raya Utama, Lengkong Kulon, Kec. Pagedangan,
            Kabupaten Tangerang, Banten 15331
            <br /> Indonesia
          </Typography>

          <Typography variant='body2' sx={{ mt: 1 }}>
            <strong>Marketing:</strong> Junius
            <br />
            <strong>Phone:</strong>{' '}
            <Link href={`tel:${CONTACT.phone}`} sx={linkStyle}>
              {CONTACT.phoneDisplay}
            </Link>
            <br />
            <strong>Email:</strong>{' '}
            <Link href={`mailto:${CONTACT.email}`} sx={linkStyle}>
              {CONTACT.email}
            </Link>
          </Typography>
        </Grid>

        {/* TENTANG */}

        <Grid item xs={12} sm={6} md={3}>
          <Typography variant='subtitle1' fontWeight='bold' sx={{ mb: 2 }}>
            Tentang Saya - Junius
          </Typography>

          <Typography variant='body2'>
            Marketing Mobil BYD di BSD Tangerang.
            <br /> Temukan kendaraan canggih dan eco-friendly bersama saya.
            Hubungi untuk test drive dan info lebih lanjut.
          </Typography>

          <Stack direction='row' spacing={1} mt={2}>
            <IconButton href={`tel:${CONTACT.phone}`} sx={phoneIcon}>
              <PhoneIcon />
            </IconButton>

            <IconButton
              href={createWhatsAppUrl(
                'Halo, saya ingin mengetahui informasi BYD di BSD Serpong.',
              )}
              target='_blank'
              sx={waIcon}
            >
              <WhatsAppIcon />
            </IconButton>

            <IconButton
              href='https://instagram.com/bydbsdserpong'
              target='_blank'
              sx={igIcon}
            >
              <InstagramIcon />
            </IconButton>

            <IconButton href={`mailto:${CONTACT.email}`} sx={emailIcon}>
              <EmailIcon />
            </IconButton>
          </Stack>
        </Grid>
      </Grid>

      <VisitorStats />

      <Divider sx={{ backgroundColor: '#4c4c4c', marginY: '30px' }} />

      <Typography
        variant='body2'
        sx={{ fontSize: '14px', lineHeight: 1.5, mb: 1, textAlign: 'center' }}
      >
        Saya Junius, spesialis pemasaran mobil listrik <strong>BYD</strong> di
        BSD Tangerang. Hubungi saya untuk jadwal test drive dan penawaran
        langsung dari dealer resmi <strong>BYD BSD Serpong</strong>.
      </Typography>

      <Typography
        variant='body2'
        sx={{ fontSize: '13px', lineHeight: 1.5, textAlign: 'center' }}
      >
        © {new Date().getFullYear()} BYD BSD Serpong. All Rights Reserved.
        Powered by gumiho.world
      </Typography>
    </Box>
  );
}

const linkStyle = {
  color: '#cccccc',

  textDecoration: 'none',

  fontSize: '14px',

  '&:hover': { color: '#FF6A00' },
};

const phoneIcon = {
  backgroundColor: '#5A9BD4',

  color: '#fff',

  '&:hover': { backgroundColor: '#4682B4' },
};

const waIcon = {
  backgroundColor: '#25D366',

  color: '#fff',

  '&:hover': { backgroundColor: '#1EBE54' },
};

const emailIcon = {
  backgroundColor: '#EA4335',

  color: '#fff',

  '&:hover': { backgroundColor: '#C62828' },
};

export default Footer;
